/**
 * Icon URLs for quest / mission / defense reward keys (resources, ECS, XP, etc.).
 */
export const GIFT_RESOURCE_ICONS: Record<string, string> = {
  water: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Eclipsera/water_reward_icon.webp',
  wheat: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/wheat-icon.webp',
  bread: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/bread-icon.webp',
  wood: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/wood-icon.webp',
  stone: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/stone-icon.webp',
  iron: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/land/iron-icon.webp',
  ecs: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/eclipsera-gem.webp',
  experience: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Eclipsera/Images/Inventory/star.webp',
  userExp: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Eclipsera/Images/Inventory/star.webp',
  characterExp: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/_merged_/Eclipsera/Images/Inventory/star.webp',
  lootItems: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/box.webp',
  gemItems: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/box.webp',
  // Crafting materials granted by mission rewards (e.g. Day-1 Claymore quest line)
  leather: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/craft_items/leather.webp',
  'rhinoceros-horn': 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/craft_items/rhinoceros-horn.webp',
  'dragon-fang': 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/craft_items/dragon-fang.webp',
  // Hero-request kit granted by the general-visit mission (loot + disaster gems)
  loot: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/box.webp',
  'nano-catalyst': 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/nano-catalyst.webp',
  'aqua-shield': 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/aqua-shield.webp',
  voltstone: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/voltstone.webp',
  froststone: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/froststone.webp',
  tempest: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/tempest.webp',
  seismic: 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/seismic.webp',
  'sunshard-prosper': 'https://s0swaypl0zqnzq8t.public.blob.vercel-storage.com/items/sunshard-prosper.webp',
}
